import { useMediaQuery } from '@vueuse/core'

import { DESKTOP_MEDIA } from '~/scopes/campaign/const/config.const'

// Single source of truth for the dual-rail split (≥lg, see DESKTOP_MIN_WIDTH): the
// width at which the impacts rail and the right modal fit side by side instead of
// taking the screen one at a time. The camera padding reads it, so the two agree.
//
// Returns the raw media-query ref. It's true only once past the breakpoint, which
// on the server is false — callers that gate *rendered* output (not just imperative
// logic) must still guard with a mounted flag to avoid a hydration mismatch.
export function useIsDesktop() {
  return useMediaQuery(DESKTOP_MEDIA)
}
